// extracted by mini-css-extract-plugin
export var buttonContainer = "_8h-1";
export var fontSizeSelect = "_8h-3";
export var formatSelect = "_8h-2";
export var formats = "_8h-4";
export var hidden = "_8h-5";
export var icon = "_8h-6";
export var select = "_8h-0";